import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useDeselectShortcut() {
  const { getNodes, setNodes } = useReactFlow();

  const deselectIfAnySelected = (e: KeyboardEvent) => {
    const nodes = getNodes();
    if (!nodes.some((n) => n.selected)) return;
    e.preventDefault();
    setNodes(nodes.map((n) => ({ ...n, selected: false })));
  };

  // Plain Escape (no modifiers).
  useKeyboardShortcut(
    { key: 'Escape', meta: false, shift: false, alt: false },
    deselectIfAnySelected,
  );
  // Cmd/Ctrl + Shift + A.
  useKeyboardShortcut(
    { key: 'a', meta: true, shift: true },
    deselectIfAnySelected,
  );
}
